/**
 * Transforms a MapLibre style from kebab-case (web) to camelCase (React Native).
 */

function kebabToCamel(str: string): string {
  return str.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase());
}

function transformKeys(obj: unknown): unknown {
  if (obj === null || obj === undefined) return obj;
  if (Array.isArray(obj)) return obj.map(transformKeys);
  if (typeof obj !== "object") return obj;

  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(obj as Record<string, unknown>)) {
    const newKey = kebabToCamel(key);
    result[newKey] = typeof value === "object" ? transformKeys(value) : value;
  }
  return result;
}

/**
 * Deep-converts all keys in paint/layout/source objects from kebab-case to camelCase.
 * Returns a plain object (not typed as StyleSpecification since keys differ).
 */
export function transformForReactNative(style: unknown): unknown {
  return transformKeys(style);
}
